import { Modal } from 'antd'
import styled from 'styled-components'

const StyledHistoryModal = styled(Modal)`
  width: 900px !important;

  .ant-modal-body {
    padding: 0px 8px;
  }
`

export default StyledHistoryModal
